import React from "react";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Checkbox from "@mui/material/Checkbox";
import CheckIcon from "@mui/icons-material/Check";
import DeleteIcon from "@mui/icons-material/Delete";
import FullscreenIcon from "@mui/icons-material/Fullscreen";

const hasDisplayValue = (value) =>
  value !== null && value !== undefined && String(value).trim() !== "";

const formatAcademicStanding = (student, toTitleCase) => {
  const parts = [];

  if (hasDisplayValue(student.GPA)) {
    parts.push(toTitleCase(student.GPA));
  }

  if (hasDisplayValue(student.GradePercent)) {
    parts.push(`${toTitleCase(student.GradePercent)}%`);
  }

  return parts.length ? parts.join(" / ") : "N/A";
};

const StudentNominations = ({
  loadingStudents,
  schoolColors,
  groupedStudents,
  activeStudent,
  studentsToAward,
  isSchoolAdmin,
  isRecorder,
  isSelPanel,
  canDriveSelection,
  canManageNominations,
  canManageStudentNomination,
  handleSelectStudentDetails,
  setViewStudent,
  setViewStudentModalOpen,
  handleToggleAwardStudent,
  handleRemoveStudent,
  adminStatus,
  toTitleCase,
}) => {
  if (loadingStudents) {
    return (
      <Box textAlign="center">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <TableContainer component={Paper} sx={{ mt: 2 }}>
      <Table size="small">
        <TableHead>
          <TableRow>
            {Object.keys(schoolColors).map((school) => (
              <TableCell
                key={school}
                sx={{
                  fontWeight: "bold",
                  backgroundColor: schoolColors[school] || "#EAEAEA",
                  textAlign: "center",
                  width: `${100 / Object.keys(schoolColors).length}%`,
                  minWidth: "120px",
                }}
              >
                {school}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            {Object.keys(schoolColors).map((school) => (
              <TableCell key={school}>
                {groupedStudents[school]?.map((student) => (
                  <Paper
                    key={student.id}
                    sx={{
                      padding: "8px",
                      marginBottom: "4px",
                      backgroundColor:
                        activeStudent?.id === student.id
                          ? "#d3e3fd"
                          : "transparent",
                      border: studentsToAward.has(student.id)
                        ? "2px solid green"
                        : "none",
                      cursor: "pointer",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      textAlign: "center",
                    }}
                    onClick={() =>
                      !(isSchoolAdmin && !isRecorder) && handleSelectStudentDetails(student)
                    }
                  >
                    <Typography
                      variant="body2"
                      sx={{ fontWeight: "bold", marginBottom: "4px" }}
                    >
                      {toTitleCase(student.last_name)},{" "}
                      {toTitleCase(student.first_name)}
                    </Typography>
                    <Typography
                      variant="body2"
                       sx={{
                        color: "gray",
                        fontSize: "0.75rem",
                        marginBottom: "4px",
                      }}
                    >
                      {formatAcademicStanding(student, toTitleCase)}
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        color: "gray",
                        fontSize: "0.75rem",
                        marginBottom: "4px",
                      }}
                    >
                      Awarded:{" "}
                      {student?.awardHistory?.length
                        ? `$${student.awardHistory
                            .reduce((sum, a) => sum + (a?.award_amount || 0), 0)
                            .toLocaleString()}`
                        : "None"}
                    </Typography>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "90%",
                      }}
                    >
                      {studentsToAward?.has(student.id) && (
                        <CheckIcon
                          size="small"
                          sx={{ ml: 0, color: "green" }}
                        />
                      )}
                      <IconButton
                        size="small"
                        color="primary"
                        onClick={(e) => {
                          e.stopPropagation();
                          setViewStudent(student);
                          setViewStudentModalOpen(true);
                        }}
                      >
                        <FullscreenIcon fontSize="small" />
                      </IconButton>
                      {canDriveSelection && (
                        <>
                          <Checkbox
                            size="small"
                            checked={studentsToAward?.has(student.id)}
                            onChange={() => handleToggleAwardStudent(student.id)}
                          />
                          <IconButton
                            size="small"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleRemoveStudent(student.id);
                            }}
                          >
                            <DeleteIcon fontSize="small" />
                          </IconButton>
                        </>
                      )}
                      {!canDriveSelection &&
                        canManageNominations &&
                        canManageStudentNomination?.(student) && (
                          <IconButton
                            size="small"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleRemoveStudent(student.id);
                            }}
                          >
                            <DeleteIcon fontSize="small" />
                          </IconButton>
                        )}
                    </Box>
                  </Paper>
                ))}
              </TableCell>
            ))}
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default StudentNominations;
